import { render, staticRenderFns } from "./multiList.vue?vue&type=template&id=6a0f6524&scoped=true"
import script from "./multiList.vue?vue&type=script&lang=js"
export * from "./multiList.vue?vue&type=script&lang=js"
import style0 from "./multiList.vue?vue&type=style&index=0&id=6a0f6524&prod&lang=scss"
import style1 from "./multiList.vue?vue&type=style&index=1&id=6a0f6524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f6524",
  null
  
)

export default component.exports